module.exports = __webpack_public_path__ + "img/jg1.c87aa506.png";